import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from 'esr-core/app'

import './index.css'
import { CONFIG } from "./config.ts";
import ViewBase1 from "esr-core/view_base_1";
import ViewBase2 from "./view_base_2.tsx";
import ViewBase3 from "esr-core/view_base_3";
import ViewCurrentState from "esr-core/view_current_state";
import ViewFutureState from "esr-core/view_future_state";
import ViewCalculation from "esr-core/view_calculation";

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App config={CONFIG}>
        <ViewBase1/>
        <ViewBase2/>
        <ViewBase3/>
        <ViewCurrentState/>
        <ViewFutureState/>
        <ViewCalculation/>
    </App>
  </StrictMode>
)
